module.exports = __webpack_public_path__ + "img/checkbox_active.9c02ca7c.svg";